'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeGoogleAnalytics = initializeGoogleAnalytics;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */
function setup() {
    var url = '//www.google-analytics.com/analytics.js';

    window.GoogleAnalyticsObject = 'ga';
    window.ga = window.ga || function innerInit() {
        (window.ga.q = window.ga.q || []).push(arguments);
    };
    window.ga.l = Date.now();

    return new Promise(function (resolve, reject) {
        var tag = document.createElement('script');
        tag.async = 1;
        tag.onload = resolve;
        tag.onerror = reject;
        tag.src = url;

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

function alternativeClientId() {
    var id = _jsCookie2.default.get('utClientId');
    if (!id) {
        id = 'UT.' + Date.now() + Math.random().toString().substr(1);

        _jsCookie2.default.set('utClientId', id, { expires: 365 * 2 });
    }

    return id;
}

/**
 * accept settings like
 *
 * ...
 * "googleAnalytics": {
 *     // tracking id from https://analytics.google.com
 *     "trackingId": "UA-NNNNNN-N",
 *
 *     // cross-domain tracking https://developers.google.com/analytics/devguides/collection/analyticsjs/linker
 *     "linkDomains": ["domain1.com", "domain2.net"],
 *
 *     //and any valid options from https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#create
 * },
 * ...
 */
function initGoogleAnalytics(gaSettings) {
    var setupPromise = setup();
    var ga = window.ga;

    var domains = gaSettings.linkDomains;
    delete gaSettings.linkDomains;

    var gaConfig = Object.assign({
        cookieDomain: 'auto',
        allowLinker: domains && domains.length > 0
    }, gaSettings);

    ga('create', gaConfig);

    if (gaConfig.allowLinker) {
        ga('require', 'linker');
        ga('linker:autoLink', domains);
    }

    return { ga: ga, setupPromise: setupPromise };
}

function addGoogleAnalyticsHistoryListener(historyComponent) {
    if (!window.ga) {
        return;
    }
    historyComponent.listen(function (location) {
        var ga = window.ga;

        // separate setting and sending
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications#tracking_virtual_pageviews
        ga('set', 'page', location.pathname);
        ga('send', 'pageview');
    });
}

function initializeGoogleAnalytics(application) {
    var settings = application.settings;
    try {
        var googleAnalytics = settings.get('googleAnalytics');

        var _initGoogleAnalytics = initGoogleAnalytics(googleAnalytics),
            setupPromise = _initGoogleAnalytics.setupPromise,
            ga = _initGoogleAnalytics.ga;

        application.ga = ga;
        application.getClientId = function () {
            return setupPromise.then(function () {
                return window.ga.getAll()[0].get('clientId');
            }).catch(function () {
                return alternativeClientId();
            });
        };

        addGoogleAnalyticsHistoryListener(application.history);
    } catch (e) {
        application.logger.warn('can\'t read google analytics config. skip initialization. ' + e.message);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/googleAnalyticsIntegration.js
// module id = 1325
// module chunks = 118